import React from 'react';
import { findDOMNode } from 'react-dom';
import { injectIntl } from 'react-intl';
import { isEmpty, get, map, includes, sortBy, size } from 'lodash';
import { Modal } from 'react-overlays';
import DateFacet from './date-facet';
import { FacetItem } from './facet-item';

const modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0, bottom: 0, left: 0, right: 0
};

const backdropStyle = {
  ...modalStyle,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5
};


const Facets = (props) => {
  if (isEmpty(props.data)) return null;

  const {
    availableFacets,
    facetSpotlightSearches,
    expandedFacetBlocks,
    isFething,
    updateRecallsDates,
    selectedFacets,
    dates,
    ...rest
  } = props;

  return (
    <div>
      <Modal
        style={modalStyle}
        show={isFething}
        backdropStyle={backdropStyle}
      >
        <div/>
      </Modal>
      {
        map(sortBy(availableFacets, 'conf.index'), (facet) => (
            <FacetItem
              {...rest}
              key={facet.conf.key}
              facet={facet}
              selectedCount={size(get(selectedFacets, facet.conf.key, []))}
              isExpanded={includes(expandedFacetBlocks, facet.conf.key)}
              isFilterable={get(facet, 'valuesCount', size(facet.data)) > 10}
              spotlight={get(facetSpotlightSearches, facet.conf.key)}
            />
          )
        )
      }
      <DateFacet dates={dates} updateRecallsDates={updateRecallsDates}/>
    </div>
  );
};

export default injectIntl(Facets);



// WEBPACK FOOTER //
// ./src/views/recalls-list/facets/index.js